import { adminApiFetch } from './apiService';

export const profileService = {
  // 獲取用戶資料
  get: async (userId) => {
    const response = await adminApiFetch(`users/${userId}`, { method: 'GET' });
    return response.json();
  },

  // 更新基本資訊
  update: async (userId, data) => {
    const response = await adminApiFetch(`users/${userId}`, {
      method: 'PATCH',
      body: JSON.stringify(data)
    });
    return response.json();
  },

  // 更新密碼
  updatePassword: async (userId, data) => {
    const response = await adminApiFetch(`users/${userId}/update_password`, {
      method: 'PATCH',
      body: JSON.stringify(data)
    });
    return response.json();
  },

  // 取得通知訂閱偏好
  getNotificationPreferences: async () => {
    const response = await adminApiFetch('notification_subscriptions', { method: 'GET' });
    return response.json();
  },

  // 更新通知訂閱偏好
  updateNotificationPreferences: async (subscriptions) => {
    const response = await adminApiFetch('notification_subscriptions', {
      method: 'PUT',
      body: JSON.stringify({ subscriptions })
    });
    return response.json();
  }
};

export default profileService;
